import { render, staticRenderFns } from "./FeedbackController.vue?vue&type=template&id=7cf0d814&scoped=true&"
import script from "./FeedbackController.vue?vue&type=script&lang=js&"
export * from "./FeedbackController.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackController.vue?vue&type=style&index=0&id=7cf0d814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf0d814",
  null
  
)

export default component.exports